import 'jquery.waitforimages';

import $ from 'jquery';
import Isotope from 'isotope-layout';
import _ from 'underscore';
import lozad from 'lozad';

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();


// Project overlay

var overlayMarkup = `
      <div class="project-overlay">
      	<div class="container">
      		<div class="close top">
      			<i class="icon-close"></i>
      		</div>
      		<div class="load-container"></div>
      		<div class="close bottom">
      			<i class="icon-close"></i>
      		</div>
      	</div>
      	<div class="project-loader"></div>
      </div>
    `;
var $overlay = $(overlayMarkup).prependTo('body');
var overlayTriggers = 'a[href*="/portfolio/"]:not([href$="/portfolio/"])';

$(document).on('click', overlayTriggers, function(e) {
  e.preventDefault();

  // $('body').addClass('no-scroll');
  //
  // var $loadContainer = $overlay
  //   .addClass('visible loading')
  //   .find('.load-container')
  //
  //   console.log(_.last( _.compact( $(this).attr('href').split('/') ) ));
  //
  // $.ajax({
  //   url: projectQuery.ajaxurl,
  //   type: 'post',
  //   data: {
  //     action: 'get_single_project',
  //     query_vars: projectQuery.query_vars,
  //     projectSlug: _.last( _.compact( $(this).attr('href').split('/') ) ),
  //   },
  //   success: function( html ) {
  //     $loadContainer.html(html);
  //     $overlay.scrollTop(0);
  //
  //     $loadContainer.waitForImages(function() {
  //         buildMasonry();
  //
  //         $overlay.removeClass('loading');
  //     });
  //     $loadContainer.find(overlayTriggers).css('pointer-events', 'all');
  //   }
  // })

  var projectUrl = '/blog/portfolio/' + _.last(_.compact($(this).attr('href').split('/')));

  $('body').addClass('no-scroll');

  $overlay.addClass('visible loading').find('.load-container').load(projectUrl + ' .single-project-wrapper', function() {
    $overlay.scrollTop(0);


      buildMasonry();

      $overlay.removeClass('loading');

    $(this).find(overlayTriggers).css('pointer-events', 'all');
  });
});

$(overlayTriggers).css('pointer-events', 'all');

$overlay.find('.close').click(function() {
  $overlay.removeClass('visible');
  $('body').removeClass('no-scroll');
});

function buildMasonry() {
  var $gallery = $overlay.find('.project-gallery');
  var $items = $gallery.children('.grid-item');

  var gridPattern = [2, 1, 1, 2, 3];

  $items.each(function(index) {
    var spanColumns = gridPattern[index % gridPattern.length];
    var $image = $(this).find('img').get(0);
    if (spanColumns === 3 && $image.naturalWidth < 1100) {
      spanColumns = 2;
    }

    $(this).addClass('grid-width-' + spanColumns)
  });

  $items.find('img').prop('draggable', false);

  $gallery.waitForImages(function() {
    new Isotope($gallery.get(0), {
      itemSelector: '.grid-item',
      layoutMode: 'fitRows'
    });
  })
}

var hash = window.location.hash;
if (hash && hash.length > 1) {
  hash = hash.slice(1);

  $('a[href*="/portfolio/"][href*="/' + hash + '/"]').click();
}

// Archive filters

$('.filter-toggle').click(function() {
  $(this).add('.filter-cat-list').toggleClass('open');
});

var $archiveGrid = $('.portfolio-archive .grid');
if ($archiveGrid.length) {
  const archiveGridIsotope = new Isotope($archiveGrid.get(0), {
    itemSelector: '.element-item',
    layoutMode: 'fitRows'
  });

  var $filterLinks = $('[data-filter-by]');
  $filterLinks.click(function() {
    var category = $(this).data('filter-by');
    archiveGridIsotope.arrange({
      filter: '.' + category
    });

    $filterLinks.removeClass('active');
    $(this).addClass('active');
  });
}
